import { get_project, subproject_list, kit_list, erns_list, tissue_list,group_list } from "../../../../service/apis";
import auth from '../../../../service/Auth';

const config = window.config;

const getErrorObject = (experiment, message) => {
    return { experiment: experiment, reason: message};
}

const checkBoolean = (field) => {
    let booleanValue = field;
    return (booleanValue === 'true' || booleanValue === 'false');
}

const checkProject = async(project_name) => {
    if (project_name === "") return [];
    const response = await get_project(auth.getToken(),config.api_endpoint, project_name);
    return await response.text();
}

const checkSubproject = async(subproject_name) => {
    const response = await subproject_list(auth.getToken(),config.api_endpoint);
    const data = await response.json();
    return data.findIndex((subproject) => subproject.name === subproject_name);
}

export const validate = async(experimentFields) => {
    let error = {};
    const experimentId = experimentFields["ExperimentID"];
    //1. Local Experiment ID Can not have empty spaces
    if ("LocalExperimentID" in experimentFields) {
        const indexWhiteSpace = experimentFields["LocalExperimentID"].search(" ");
        if (indexWhiteSpace > -1) {
            return getErrorObject(experimentId, "LocalExperimentID can not have white spaces.");
        }
    }
    //2. Owner must be a declared one
    if ("Owner" in experimentFields) {
        const response = await group_list(auth.getToken(),config.api_endpoint);
        const data = await response.json();
        const searchIndex = data.findIndex((group) => group.name === experimentFields["Owner"]);
        if (searchIndex === -1) {
            return getErrorObject(experimentId, "Owner " + experimentFields["Owner"] + " does not exists.");
        }        
    }
    //3. Project must be a declared one
    if ("project" in experimentFields) {
        const data = await checkProject(experimentFields["project"]);
        if (data.length === 0) {
            return getErrorObject(experimentId, "Project " + experimentFields["project"] + " does not exists.");
        }
    }
    //4. Delete Project must be a declared one
    if ("delete_project" in experimentFields) {
        const data = await checkProject(experimentFields["delete_project"]);
        if (data.length === 0) {
            return getErrorObject(experimentId, "Delete project " + experimentFields["delete_project"] + " does not exists.");
        }
    }
    //5. Subproject must be a declared one
    if ("subproject" in experimentFields) {
        const searchIndex = await checkSubproject(experimentFields["subproject"]);
        if (searchIndex === -1) {
            return getErrorObject(experimentId, "Subproject " + experimentFields["subproject"] + " does not exists.");
        }
    }
    //6. Subproject must be a declared one
    if ("delete_subproject" in experimentFields) {
        const searchIndex = await checkSubproject(experimentFields["delete_subproject"]);
        if (searchIndex === -1) {
            return getErrorObject(experimentId, "Delete subproject " + experimentFields["delete_subproject"] + " does not exists.");
        }
    }
    //7. Kit must be a valid one
    if ("kit" in experimentFields) {
        const response = await kit_list(auth.getToken(),config.api_endpoint);
        const data = await response.json();
        const searchIndex = data.findIndex((kit) => kit.kit_name === experimentFields["kit"]);
        if (searchIndex === -1) {
            return getErrorObject(experimentId, "kit " + experimentFields["kit"] + " does not exists.");
        }
    }
    // 8. Tissue must be a declared one
    if ("tissue" in experimentFields) {
        const response = await tissue_list(auth.getToken(),config.api_endpoint);
        const data = await response.json();
        const searchIndex = data.findIndex((tissue) => tissue.name === experimentFields["tissue"]);
        if (searchIndex === -1) {
            return { experiment: experimentFields["ExperimentID"], 
                     reason: "tissue  " + experimentFields["tissue"] + " does not exists."};
        }            
    }
    // 9. ERNs must be a declared one
    if ("erns" in experimentFields) {
        const response = await erns_list(auth.getToken(),config.api_endpoint);
        const data = await response.json();
        const searchIndex = data.findIndex((erns) => erns.name === experimentFields["erns"]);
        if (searchIndex === -1) {
            return getErrorObject(experimentId, "ERNs " + experimentFields["erns"] + " does not exists.");
        }
    }
    // 10. In Platform must a be a boolean value
    if ("in_platform" in experimentFields) {
        if (! checkBoolean(experimentFields["in_platform"])) {
            return getErrorObject(experimentId, "in_platform must be true or false");
        }
    }
    // 11. Processed must a be a boolean value
    if ("processed" in experimentFields) {
        if (! checkBoolean(experimentFields["processed"])) {
            return getErrorObject(experimentId, "processed must be true or false");
        }
    }
    return error;
}
